export const PAYMENT_RESULT_QUERY = "payment";

export type PaymentResultStatus = "success" | "fail";

export const PAYMENT_RESULT_SUCCESS: PaymentResultStatus = "success";
export const PAYMENT_RESULT_FAIL: PaymentResultStatus = "fail";

export const isPaymentResultStatus = (
  value: string | null | undefined
): value is PaymentResultStatus =>
  value === PAYMENT_RESULT_SUCCESS || value === PAYMENT_RESULT_FAIL;

export const getPaymentResultPath = (status: PaymentResultStatus): string =>
  `/?${PAYMENT_RESULT_QUERY}=${status}`;
